import { Injectable } from '@angular/core';
import { AuthenticationService } from './authentication.service';

export interface RouteEndpointPreference {
  skipPrompt: boolean;
}

@Injectable({ providedIn: 'root' })
export class RouteEndpointPreferenceService {
  private readonly storagePrefix = 'tpslRoute.endpoints.';

  constructor(private authenticationService: AuthenticationService) {}

  get(routeId: number): RouteEndpointPreference | null {
    const key = this.storageKey(routeId);
    if (!key) { return null; }
    try {
      const value = localStorage.getItem(key);
      if (!value) { return null; }
      const parsed = JSON.parse(value);
      return { skipPrompt: parsed.skipPrompt === true };
    } catch (error) { return null; }
  }

  set(routeId: number, preference: RouteEndpointPreference): void {
    const key = this.storageKey(routeId);
    if (!key) { return; }
    try { localStorage.setItem(key, JSON.stringify(preference)); } catch (error) { /* Storage may be unavailable. */ }
  }

  private storageKey(routeId: number): string | null {
    const user = this.authenticationService.currentUserValue;
    if (!user || !routeId) { return null; }
    const identity = typeof user.UserID === 'number' && user.UserID > 0
      ? 'id:' + user.UserID.toString()
      : user.UserName ? 'name:' + encodeURIComponent(user.UserName) : null;
    return identity ? this.storagePrefix + identity + '.route:' + routeId.toString() : null;
  }

}
